
import { useBlockProps } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { logos, template, animationDuration, showAltText, logoSize, slideDirection } = attributes;
	const blockProps = useBlockProps.save();

	return (
		<div { ...blockProps }>
			<div 
				className={ `logo-carousel logo-carousel--${ template } logo-carousel--${ slideDirection }` }
				data-animation-duration={ animationDuration }
				data-logo-size={ logoSize }
				data-slide-direction={ slideDirection }
			>
				<div className="logo-carousel__track">
					{ logos.concat( logos ).map( ( logo, index ) => (
						<div key={ index } className="logo-carousel__item">
							{ logo.link ? (
								<a href={ logo.link } target="_blank" rel="noopener noreferrer">
									<img src={ logo.url } alt={ logo.alt } style={{ maxWidth: `${logoSize}px` }} />
									{ showAltText && logo.alt && (
										<span className="logo-carousel__alt-text">{ logo.alt }</span>
									) }
								</a>
							) : (
								<>
									<img src={ logo.url } alt={ logo.alt } style={{ maxWidth: `${logoSize}px` }} />
									{ showAltText && logo.alt && (
										<span className="logo-carousel__alt-text">{ logo.alt }</span>
									) }
								</>
							) }
						</div>
					) ) }
				</div>
			</div>
		</div>
	);
}
